package nl.astraeus.wiki.messages

class GetPageMessage() : Message(
  MessageType.GET_PAGE,
  MessageHeader.PAGE_ID,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(pageId: Long) : this() {
    setHeader(MessageHeader.PAGE_ID, pageId.toString())
  }

}
